import { Components, Theme } from '@mui/material/styles'

export const MuiAvatar: Components<Theme>['MuiAvatar'] = {
  styleOverrides: {
    root: ({ theme }) => ({
      width: '36px',
      height: '36px',
      border: `1px solid ${theme.palette.grey[400]}`,
      backgroundColor: '#f6f5f5',
      color: '#5b5551',
      fontSize: '14px',
    }),
  },
}
